import React, { useState, useEffect } from 'react'
import DOMPurify from 'dompurify'
import { getBREDocumentData } from './common/institutionalServiceHelper.js'
import { checkIfSSO } from '../../../global/authentication/authentication-manager.js'
import {
  regexValidationForUserId,
  isSsnFormat,
} from '../../../global/_utils.js'
import FormNotification from '../../../components/SelfService/FormNotification.jsx'
import InputGroup from '../../../components/EmailSubscriptionCenter/SignIn/InputGroup.jsx'
import { accessStorage } from './common/institutionalConfig.js'
import {
  makeForgotPasswordRequest,
  fetchToken,
  errorMessage,
  screens,
} from './common/institutionalServiceHelper.js'

export default function InstitutionalUserId({
  screenChangeHandler,
  setShowLoader,
  forgotPasswordHandleError,
  tmxId,
}) {
  const [bannerData, setBannerData] = useState()
  const [userId, setUserId] = useState(accessStorage.getUserId())
  const [formValidation, setFormValidation] = useState({
    'login-user-id': {
      error: false,
      errorMessage: 'Enter your firm email address',
    },
  })
  const [formErrorMessage, setFormErrorMessage] = useState('')
  const [formWarningMessage, setFormWarningMessage] = useState('')

  const onUserIdChange = (e) => {
    setUserId(e.currentTarget.value)
  }

  const onContinueClicked = async () => {
    if (!userId) {
      const _formValidation = { ...formValidation }
      _formValidation['login-user-id'].error = true
      setFormValidation(_formValidation)
      return
    }
    if (isSsnFormat(userId)) {
      const _formValidation = { ...formValidation }
      _formValidation['login-user-id'].error = true
      _formValidation['login-user-id'].errorMessage =
        'The User ID you entered is incorrect. Please check and try again.'
      setFormValidation(_formValidation)
      return
    }
    const isValidUserId = regexValidationForUserId(userId)
    if (!isValidUserId?.isValid) {
      const _formValidation = { ...formValidation }
      _formValidation['login-user-id'].error = true
      _formValidation['login-user-id'].errorMessage = isValidUserId?.message
      setFormValidation(_formValidation)
      return
    }
    if (checkIfSSO(userId)) {
      const _formValidation = { ...formValidation }
      _formValidation['login-user-id'].error = true
      _formValidation['login-user-id'].errorMessage =
        'Enter correct firm email address'
      setFormValidation(_formValidation)
      return
    }
    setShowLoader(true)
    try {
      await fetchToken(tmxId)
      const data = await makeForgotPasswordRequest(
        { userEmail: userId },
        {
          action: 'forgotUid',
        }
      )
      if (data && !data.error) {
        screenChangeHandler(screens.MFA_SCREEN, {
          userEmail: userId,
          mfaData: data?.value?.routes?.value,
        })
      } else {
        if (data?.error?.details) {
          forgotPasswordHandleError(
            data.error.details.code,
            setFormErrorMessage
          )
        } else {
          forgotPasswordHandleError(data?.error?.code, setFormErrorMessage)
        }
      }
    } catch (error) {
      setFormErrorMessage(errorMessage.defaultError)
    }
    setShowLoader(false)
  }

  const onCancleClick = () => {
    screenChangeHandler(screens.CANCEL_VERIFICATION_SCREEN)
  }

  const getBREData = async () => {
    const data = await getBREDocumentData('login/security-update-banner')
    setBannerData({
      title: data[0]?.title,
      content: data[0]?.html?.content,
    })
  }

  useEffect(() => {
    getBREData()
  }, [])

  return (
    <div className="u-sizeConstrained">
      <div className="Grid">
        <div className="u-sizeFull u-lg-size12of12 u-marginBottom6gu">
          <h2 className="u-marginBottom2gu u-marginTop0">
            {bannerData?.title}
          </h2>
          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(bannerData?.content),
            }}
          ></div>
        </div>
      </div>
      <div
        className="Content u-marginTop4gu  u-marginBottom10gu"
        data-analytics-login-step="User Id"
      >
        <div className="Grid">
          <div className="u-sizeFull u-lg-size5of12 u-lg-after1of12">
            <h2 className="u-marginTop0 u-marginBottom4gu">
              Enter your Email Address
            </h2>
            {formWarningMessage && (
              <FormNotification content={formWarningMessage} status="warn" />
            )}
            {formErrorMessage && (
              <FormNotification content={formErrorMessage} isHtml={true} />
            )}
            <InputGroup
              handleInputChange={onUserIdChange}
              formValidation={formValidation}
              fieldName="login-user-id"
              fieldId="login-user-id"
              placeholder="Email Address"
              label="Email Address"
              compact={false}
              disabled={false}
              defaultValue={userId}
            />
            <div className="Grid Grid--withGutter">
              <div className="u-size6of12">
                <button
                  onClick={onContinueClicked}
                  className="Button Button--primary Button--block u-marginRight5gu u-marginBottom3gu u-paddingHoriz8gu u-textNoTransform"
                >
                  Next
                </button>
              </div>
              <div className="u-size6of12">
                <button
                  onClick={onCancleClick}
                  className="Button Button--tertiary Button--block u-paddingHoriz8gu"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
